import axiosLib from 'axios';

const axiosAuth = axiosLib.create();

export function setToken(data: Token) {
  localStorage.setItem('access_token', data.token);
  // localStorage.setItem('refresh_token', data.refresh_token);
}

export function getAccessToken() {
  return localStorage.getItem('access_token');
}

export function deleteToken() {
  localStorage.removeItem('access_token');
  // localStorage.removeItem('refresh_token');
}

function getRefreshToken() {
  return localStorage.getItem('refresh_token');
}

axiosAuth.interceptors.request.use((request) => {
  const token = getAccessToken();
  if (token) {
    request.headers.Authorization = `${getAccessToken()}`;
  }

  return request;
});

export default axiosAuth;
